<template>
  <div id="app">
    <!--    <img alt="Vue logo" src="./assets/logo.png">-->
    <!-- Vue passes parameters via bind eg v-bind:list or :list for short.
      Vue recognises callables on computed:
      filtered_products_rest takes a list_name parameter.
     -->
    <div v-if="filtered_products.length === 0">NO RESULTS FOUND</div>
    <DigitalCarousel
      :list="featured_products"
      :items-to-show="2"
      title="Featured"
    />
    <DigitalCarousel
      :list="latest_products"
      :items-to-show="3"
      title="Latest"
    />
    <DigitalCarousel
      v-for="available_type in product_available_types"
      :items-to-show="3"
      :key="available_type.slug"
      :title="available_type.name"
      :list="filtered_products"
      :filter_slug="available_type.slug"
    />
  </div>
</template>

<script>
import DigitalCarousel from "./components/DigitalCarousel.vue";
import _ from "lodash";

export default {
  name: "App",
  components: {
    DigitalCarousel: DigitalCarousel,
  },
  props: ["products", "filter_choices", "product_available_types"],
  computed: {
    // computed functions are dynamic, they are called on any change, to re-process data based on the change.
    // They do not take any parameters.
    has_filtered: function () {
      // let vm = this;
      let filter = false;
      let choice_keys = Object.keys(this.filter_choices);
      for (let i in choice_keys) {
        let choice_types = choice_keys[i];
        filter = Object.values(this.filter_choices[choice_types]).some(
          (item) => item == true
        );
        if (filter) break;
      }
      return filter;
    },
    featured_products: function () {
      return this.filtered_products.filter(function (product) {
        return product.featured === true;
      });
      // return this.product_filter(featured_items, "FEATURED")
    },
    latest_products: function () {
      // This needs no filtering.
      return this.filtered_products;
    },
    filtered_products: function () {
      if (!this.has_filtered && !this.filter_choices.text_search) {
        return this.products;
      }
      let products_filtered_by_type = this._filter_product_by(
        "product_type",
        "list_types"
      );
      let products_filtered_by_access_types = this._filter_product_by(
        "member_type",
        "access_types"
      );
      let products_filtered_by_search = this._search_filter(this.products);

      if (
        products_filtered_by_type.length === 0 &&
        products_filtered_by_search.length === 0 &&
        products_filtered_by_access_types.length === 0
      )
        return [];
      // todo: Confirm with client if search is exclusive or inclusive.

      // One or more of these products is filtered, for the intersection to work any products that
      // has no data, need to be set to all data.
      // Intersect will then filter out all that data except for matching data, across all filter lists.
      products_filtered_by_type = products_filtered_by_type.length
        ? products_filtered_by_type
        : this.products;
      products_filtered_by_access_types =
        products_filtered_by_access_types.length
          ? products_filtered_by_access_types
          : this.products;
      products_filtered_by_search = products_filtered_by_search.length
        ? products_filtered_by_search
        : this.products;
      return _.intersectionBy(
        _.intersectionBy(
          products_filtered_by_type,
          products_filtered_by_access_types,
          "slug"
        ),
        products_filtered_by_search,
        "slug"
      );
    },
  },
  methods: {
    /*
            Methods are used for the business logic only, they play no direct part in dynamic (computed) changes.
            Methods can however refer to dynamic properties and change them, which will trigger an update (provided
            the method is called from a computed method).
            */
    _filter_product_by(filter_key, product_property) {
      /**
       * A generic filter that filters by the active selections in the
       * filter choices, for the given filter key.
       */
      // Generic filter function used by computed property.
      let filter_keys = this.filter_choices[filter_key];
      let new_list = this.products.filter(function (product) {
        let match = false;
        for (let key in filter_keys) {
          let value = filter_keys[key];
          match = value && product[product_property].includes(key);
          if (match) return match;
        }
        return false;
      });
      return new_list;
    },
    _search_filter: function (list) {
      /**
       * Search filter, performs a "contains" filtration on the provided list.
       * @type {default.methods}
       */
      let vm = this;
      return list.filter(function (product) {
        return product.title.includes(vm.filter_choices["text_search"]);
      });
    },
  },
  mounted: function () {
    this.current_filtered_list = this.filtered_products;
  },
};
</script>